import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import AddUser from './AddUser.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
// import Loader from '../../../../components/Shared/Loader/Loader.js';
import useGetUsers from '../../../../hooks/NTX/useGetUsers';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';
import Select from 'react-select';
import EditUser from './EditUser.jsx';
import RulesUser from '../RulesUser/RulesUser';

function Users() {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);

  const [search, setSearch] = useState('');

  const { Users, loading, error } = useGetUsers();

  const filteredSearch = Users?.slice()
    ?.filter((item) => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.usersName?.toLowerCase().includes(searchLowerCase) ||
        item.refName?.toLowerCase().toString().includes(searchLowerCase) ||
        item.refName2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter((f) => {
      if (selectedOption?.value === 'active') return f.isActive === true;
      if (selectedOption?.value === 'inactive') return f.isActive === false;
      return true; // إذا كانت القيمة 'all'، أعرض الكل
    });

  const columns = [
    { title: t('UserName'), key: 'Name', className: 'w-25' },
    { title: t('EmployeeName'), key: 'EmployeeName', className: 'w-25' },
    { title: t('TypeOfUser'), key: 'TypeOfUser', className: 'w-25' },
    { title: t('isActive'), key: 'isActive', className: 'w-25' },
    { title: t(''), key: 'action', className: 'text-end w-25' },
  ];

  const tableData = filteredSearch?.map((item) => {
    let rowClass;

    let userTypeLabel;
    switch (item.userType) {
      case 'EMPLOYEE':
        userTypeLabel = t('employee');
        break;
      case 'CONTRACTORS':
        userTypeLabel = t('CONTRACTORS');
        break;
      case 'SUPPLIERS':
        userTypeLabel = t('supplier');
        break;
      case 'CUSTOMERS':
        userTypeLabel = t('customer');
        break;
      case 'OWNERS':
        userTypeLabel = t('OWNERS');
        break;
      case 'DRIVERS':
        userTypeLabel = t('driver');
        break;
      default:
        userTypeLabel = t('Unknown');
    }

    return {
      Name: item.usersName,
      EmployeeName: i18n.language === 'en' ? item.refName : item.refName2,
      TypeOfUser: userTypeLabel,
      isActive: item.isActive ? (
        <span className="badge d-block rounded-0 pt-5px w-70px bg-success text-theme-900">
          {t('isActive')}
        </span>
      ) : (
        <span className="badge d-block rounded-0 pt-5px w-70px bg-warning  ">{t('InActive')}</span>
      ),
      action: (
        <div className="btn-group">
          {HasPermission('NtxAddpermissionsRuletoUser') && (
            <button
              type="button"
              className="btn btn-sm btn-outline-theme me-1"
              onClick={() => setItem(item)}
              data-bs-toggle="modal"
              data-bs-target="#modalRulesUser"
              // onClick={() =>
              //   Navigate(`${item.id}/RulesUser`, {
              //     state: {
              //       name: i18n.language === 'en' ? item.refName : item.refName2,
              //     },
              //   })
              // }
            >
              <i className="fa-lg fa-fw me-2 bi bi-lock-fill"></i>
              {t('UserRules')}
            </button>
          )}
          {HasPermission('NtxAddadditionalpermissionstouser') && (
            <button
              type="button"
              className="btn btn-sm btn-outline-theme me-1"
              onClick={() =>
                Navigate(`${item.id}/PermissionUser`, {
                  state: {
                    name: i18n.language === 'en' ? item.refName : item.refName2,
                  },
                })
              }>
              <i className="fas fa-lg fa-fw me-2 fa-tasks"></i>
              {t('ExtraPermissions')}
            </button>
          )}
          {HasPermission('NtxEditUser') && (
            <button
              type="button"
              className="btn btn-sm btn-outline-theme me-1"
              // onClick={() => Navigate(`${item.id}/Edit`)}
              onClick={() => setItem(item)}
              data-bs-toggle="modal"
              data-bs-target="#modalEditUsers">
              <i className="far fa-lg fa-fw m-2 fa-edit"></i>
            </button>
          )}
        </div>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  const titleModal = () => {
    return (
      <div className="">
        {t('UserRules')}
        {'  '}
        <span className="text-theme">
          {`(${i18n.language === 'en' ? item?.refName : item?.refName2})`}
        </span>
      </div>
    );
  };

  //________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'UserManagement',
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="UserManagement" />

        <div className="ms-auto">
          {HasPermission('NtxAddUser') && (
            <Link
              to=""
              className="btn me-1 btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAddUsers"
              onClick={() => setShow(true)}>
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddUser')}
            </Link>
          )}
        </div>
      </div>
      <Card>
        <CardBody>
          <Loading loading={loading} error={error}>
            <div className="row mb-2">
              <div className="col-lg-6">
                <div className="input-group flex-nowrap">
                  <span className="input-group-text fw-bold">{t('Search')}</span>
                  <div className="input-group">
                    <div className="flex-fill position-relative">
                      <div className="input-group border-0 ">
                        <div
                          className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                           >
                          <i className="fa fa-search opacity-5 text-theme"></i>
                        </div>
                        <input
                          type="text"
                          autoComplete="off"
                          className="form-control ps-35px"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="input-group flex-nowrap">
                  <span className="input-group-text  fw-bold">{t('Status')}</span>
                  <Select
                    classNamePrefix="react-select"
                    className="w-100"
                    isSearchable={true}
                    isClearable
                    options={[
                      { value: 'active', label: i18n.language === 'ar' ? 'نشط' : 'Active' },
                      { value: 'inactive', label: i18n.language === 'ar' ? 'غير نشط' : 'Inactive' },
                      { value: 'all', label: i18n.language === 'ar' ? 'الكل' : 'All' },
                    ]}
                    onChange={(option) => setSelectedOption(option)}
                    value={selectedOption}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              // enableSearch
              // showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>
      <ModalComponent title={t('AddUser')} id="modalAddUsers" size="lg">
        {show && <AddUser />}
      </ModalComponent>

      <ModalComponent title={t('UserEdit')} id="modalEditUsers" size="lg">
        {item && <EditUser userId={item?.id} />}
      </ModalComponent>

      <ModalComponent title={titleModal()} id="modalRulesUser" size="lg">
        {item && <RulesUser userId={item?.id} />}
      </ModalComponent>
    </>
  );
}

export default Users;
